import dayjs from 'dayjs'

export default {
  methods: {
    notBeforeToday (date) {
      return date < dayjs()
    },
    notNightTime (date) {
      return date.getHours() < 7 || date.getHours() > 22
    },
    notNightReservationTime (date) {
      return date.getHours() < 7 || dayjs(date).isAfter(dayjs(date).format('YYYY-MM-DDT21:00'), 'minute')
    },
    notAfterNightReservationTime (date) {
      return dayjs(date).isAfter(dayjs(date).format('YYYY-MM-DDT21:00'), 'minute')
    }
  },
  computed: {
    defaultValueInDaytime () {
      return dayjs('0800', 'HHmm')
    }
  }
}
